import { useState, useEffect } from "react";
import { useMutation } from "@apollo/client";
import {
  CREATE_BRANCH,
  DELETE_CATALOG,
  UPDATE_CATALOG,
} from "../../../services/catalogs";
import { useForm } from "react-hook-form";
import { InputText, ModalForm } from "../../../components/form";
import { DeleteUserText, ModuleTitle } from "../StylesCatalogs";

export function ModalRamo({
  showModal,
  setShowModal,
  getCatalogBranches,
  branch,
  closeModal,
  showModalEditBranch,
  showModalDeleteBranch,
  setBranchCreated,
  setUpdateBranch,
  setDeleteBranch,
}) {
  const [succes, setSucces] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({});

  const [createBranch] = useMutation(CREATE_BRANCH, {
    onCompleted({ createBranch }) {
      if (createBranch.statusCode === 200) {
        setSucces(true);
        getCatalogBranches();
        setBranchCreated({ view: true, created: true });
      } else if (createBranch.statusCode === 422) {
        setBranchCreated({
          view: true,
          created: false,
          customMessage: "El adaptador ya existe",
        });
        setSucces(false);
      }
    },
    onError(err) {
      console.log(err);
      setBranchCreated({ view: true, created: false });
      setSucces(false);
    },
  });

  const [updateBranch] = useMutation(
    UPDATE_CATALOG("updateBranch", "inputBranch"),
    {
      onCompleted({ updateBranch }) {
        if (updateBranch.statusCode === 200) {
          setSucces(true);
          getCatalogBranches();
          setUpdateBranch({ view: true, updated: true });
        }
      },
      onError(err) {
        console.log(err);
        setUpdateBranch({ view: true, updated: false });
        setSucces(false);
      },
    }
  );

  const [deleteBranch] = useMutation(
    DELETE_CATALOG("deleteBranch", "ramo_id"),
    {
      onCompleted({ deleteBranch }) {
        if (deleteBranch.statusCode === 200) {
          setSucces(true);
          console.log(succes);
          getCatalogBranches();
          setDeleteBranch({ view: true, deleted: true });
        }
      },
    }
  );

  const onSubmit = (data) => {
    if (showModalEditBranch) {
      updateBranch({
        variables: {
          input: {
            ramo_id: +branch.ramo_id,
            valor: data.nombre,
          },
        },
      });
      closeModal();
    } else if (showModalDeleteBranch) {
      deleteBranch({
        variables: {
          id: +branch.ramo_id,
        },
      });
    } else
      createBranch({
        variables: { valor: data.nombre },
      });
    closeModal();
  };

  // const hideModal = () => {
  //   setSucces(false);
  // };

  useEffect(() => {
    if (branch && showModalEditBranch) {
      reset({
        nombre: branch.nombre,
      });
    } else {
      reset({
        nombre: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const title = showModalEditBranch ? "Editar ramo" : "Agrega un nuevo ramo";
  return showModalDeleteBranch ? (
    <>
      <ModuleTitle style={{ textAlign: "center", marginBottom: "12px" }}>
        ¿Estás seguro de que deseas eliminar este ramo?
      </ModuleTitle>
      <ModalForm
        title="¿Estás seguro de que deseas eliminar este ramo?"
        textButton="Sí, eliminar ramo"
        handleSubmitRef={handleSubmit(onSubmit)}
      >
        <DeleteUserText>Este cambio es permanente</DeleteUserText>
      </ModalForm>
    </>
  ) : (
    <>
      <ModuleTitle style={{ textAlign: "center", marginBottom: "12px" }}>
        {title}
      </ModuleTitle>
      {/* {succes && <ModalSucces message="Ramo creado!" hideModal={hideModal} />} */}
      <ModalForm
        showModal={showModal}
        setShowModal={setShowModal}
        title="Agrega un nuevo ramo"
        handleSubmitRef={handleSubmit(onSubmit)}
        textButton={showModalEditBranch ? "Editar Ramo" : "Agregar Ramo"}
      >
        <InputText
          label={"Nombre de ramo"}
          type="text"
          placeholder={"Nombre"}
          name="nombre"
          control={control}
          register={{ ...register("nombre") }}
          errorMessage={errors.nuevoRamo?.type}
        />
      </ModalForm>
    </>
  );
}
